import { render, staticRenderFns } from "./cope_guide.vue?vue&type=template&id=53bab718&scoped=true&"
import script from "./cope_guide.vue?vue&type=script&lang=js&"
export * from "./cope_guide.vue?vue&type=script&lang=js&"
import style0 from "./cope_guide.vue?vue&type=style&index=0&id=53bab718&lang=scss&scoped=true&"
import style1 from "./cope_guide.vue?vue&type=style&index=1&id=53bab718&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53bab718",
  null
  
)

export default component.exports